import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import CustomerSearch from "./search/CustomerSearch";

// Rota de entrada do módulo de Clientes — por enquanto contém apenas
// a tela inicial de busca (por nome ou CPF/CNPJ).
export default function CustomerMain() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch({ type: "title", value: t("CUSTOMER.TITLE") });
  }, [dispatch, t]);

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <CustomerSearch />
    </div>
  );
}
